/**
 * Profile Settings Page (Web)
 * Placeholder for Profile Settings
 */

import { Fragment } from 'react';
import { AuthenticatedLayout } from '../../components/layout/AuthenticatedLayout';

export function ProfileSettingsPage() {
  return (
    <AuthenticatedLayout>
      <Fragment />
    </AuthenticatedLayout>
  );
}

